import moment from 'moment-timezone';

export const toLocalTimeZone = (datetimeStr: string): string => {    
    const dateTime = moment(datetimeStr);
    
    return dateTime.tz(moment.tz.guess()).format();
};

export const happenedSecondsAgo = (datetimeStr: string, seconds: number): boolean => {
    const dateTime = moment(toLocalTimeZone(datetimeStr));
    const oneMinuteAgo = moment().subtract(seconds, 'seconds');

    return dateTime.isBefore(oneMinuteAgo);
};

export const utcToLocalTimeZone = (datetimeStr: string, format?: string): string => {
    return moment.utc(datetimeStr).local().format(format);
};
